import { render, staticRenderFns } from "./wasteInsulate.vue?vue&type=template&id=495a17c2&scoped=true&"
import script from "./wasteInsulate.vue?vue&type=script&lang=js&"
export * from "./wasteInsulate.vue?vue&type=script&lang=js&"
import style0 from "./wasteInsulate.vue?vue&type=style&index=0&id=495a17c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495a17c2",
  null
  
)

export default component.exports